//router

import { createWebHistory, createRouter } from "vue-router";
import Body from "../components/body";

// error
import Error400 from "../pages/error/error400";
import Error401 from "../pages/error/error401";
import Error403 from "../pages/error/error403";
import Error404 from "../pages/error/error404";
import Error500 from "../pages/error/error500";
import Error503 from "../pages/error/error503";

/* Auth */
import login from "../auth/login";

import HomePage from "../pages/home_page.vue";
import OverviewPage from "../pages/overview_page";
import ClusterPage from "../pages/cluster_page.vue";
import LightPage from "../pages/light_page.vue";
import AnalyticsPage from "../pages/analytics_page.vue";
import SchedulerPage from "../pages/scheduler_page.vue";
import SetHoliday from "../pages/set_holiday.vue";
import AdministratorPage from "../pages/administrator_page.vue";
import DevicePage from "../pages/device_page.vue";
import GatewayPage from "../pages/gateway_page.vue";
import AdministratorClusterPage from "../pages/administrator_cluster_page.vue";
import FeederPillarPage from "../pages/feeder_pillar_page.vue";
import LuxPage from "../pages/lux_page.vue";
import OAuth from "../pages/OAuth.vue";

import { CleanUpCookies, getCookies, jwtDecode, refreshToken } from "../utils";
const routes = [
  /*{
    path: "/",
    name: "homePage",
    component: HomePage,
    meta: {
      title: "URBANLUME - SSL",
    },
  },*/
  {
    path: "/",
    redirect: "/V2/totalsolution",
    meta: {
      title: "URBANLUME - SSL",
    },
  },
  {
    path: "/home",
    component: Body,
    children: [
      {
        path: "",
        name: "defaultRoot",
        component: OverviewPage,
        meta: {
          title: "Overview - Smart Street Lighting",
        },
      },
      {
        path: "/cluster",
        name: "cluster",
        component: ClusterPage,
        meta: {
          title: "Cluster - Smart Street Lighting",
        },
      },
      {
        path: "/light",
        name: "light",
        component: LightPage,
        meta: {
          title: "Light - Smart Street Lighting",
        },
      },
      {
        path: "/lux",
        name: "lux",
        component: LuxPage,
        meta: {
          title: "Lux - Smart Street Lighting",
        },
      },
      {
        path: "/analytics",
        name: "analytics",
        component: AnalyticsPage,
        meta: {
          title: "Analytics - Smart Street Lighting",
        },
      },
    ],
  },
  {
    path: "/scheduler",
    component: Body,
    children: [
      {
        path: "",
        name: "scheduler",
        meta: {
          title: "Scheduler Time - Smart Street Lighting",
        },
        redirect: (to) => {
          return { path: "/scheduler/scheduler-time" };
        },
      },
      {
        path: "scheduler-time",
        name: "scheduler-time",
        component: SchedulerPage,
        meta: {
          title: "Scheduler Time - Smart Street Lighting",
        },
      },
      {
        path: "set-holidays",
        name: "set-holidays",
        component: SetHoliday,
        meta: {
          title: "Set Holidays - Smart Street Lighting",
        },
      },
    ],
  },
  {
    path: "/administrator",
    component: Body,
    children: [
      {
        path: "",
        name: "administrator",
        meta: {
          title: "Administrator - Smart Street Lighting",
        },
        redirect: (to) => {
          // return { path: "/administrator/user" };
          return { path: "/administrator/device" };
        },
      },
      {
        path: "user",
        name: "administrator-user",
        component: AdministratorPage,
        meta: {
          title: "User - Smart Street Lighting",
        },
      },
      {
        path: "device",
        name: "administrator-device",
        component: DevicePage,
        meta: {
          title: "Device - Smart Street Lighting",
        },
      },

      {
        path: "gateway",
        name: "administrator-gateway",
        component: GatewayPage,
        meta: {
          title: "Gateway - Smart Street Lighting",
        },
      },
      {
        path: "cluster",
        name: "administrator-cluster",
        component: AdministratorClusterPage,
        meta: {
          title: "Cluster - Smart Street Lighting",
        },
      },
      {
        path: "feeder-pillar",
        name: "administrator-feeder-pillar",
        component: FeederPillarPage,
        meta: {
          title: "Feeder Pillar - Smart Street Lighting",
        },
      },
    ],
  },
  {
    path: "/oauth",
    name: "oauth",
    component: OAuth,
    meta: {
      title: "Default Dashboard - Smart Street Lighting",
    },
  },
  {
    path: "/error-400",
    name: "Error400",
    component: Error400,
    meta: {
      title: "Error400 - Smart Street Lighting",
    },
  },
  {
    path: "/error-401",
    name: "Error401",
    component: Error401,
    meta: {
      title: "Error401 - Smart Street Lighting",
    },
  },
  {
    path: "/error-403",
    name: "Error403",
    component: Error403,
    meta: {
      title: "Error403 - Smart Street Lighting",
    },
  },
  {
    path: "/error-404",
    name: "Error404",
    component: Error404,
    meta: {
      title: "Error404 - Smart Street Lighting",
    },
  },
  {
    path: "/error-500",
    name: "Error500",
    component: Error500,
    meta: {
      title: "Error500 - Smart Street Lighting",
    },
  },
  {
    path: "/error-503",
    name: "Error503",
    component: Error503,
    meta: {
      title: "Error503 - Smart Street Lighting",
    },
  },
  {
    path: "/auth",
    children: [
      {
        path: "login",
        name: "Login 1",
        component: login,
        meta: {
          title: " login - Smart Street Lighting",
        },
      },
      // {
      //   path: "register",
      //   name: "register 1",
      //   component: Register,
      //   meta: {
      //     title: " Register - Smart Street Lighting",
      //   },
      // },
    ],
  },
  {
    path: "/V2",
    children: [
      {
        path: "login",
        name: "v2-login",
        component: () => import("../V2/login.vue"),
        meta: { title: "Login - Smart Street Lighting" },
      },
      {
        path: "totalsolution",
        name: "v2-totalsolution",
        component: () => import("../V2/totalsolution.vue"),
        meta: { title: "Total Solution - Smart Street Lighting" },
      },
      {
        path: "home",
        name: "v2-home",
        component: () => import("../V2/home.vue"),
        meta: { title: "Home - Smart Street Lighting" },
      },
      {
        path: "clusterpage",
        name: "v2-clusterpage",
        component: () => import("../V2/clusterpage.vue"),
        meta: { title: "Cluster Page - Smart Street Lighting" },
      },
      {
        path: "listlightpage",
        name: "v2-listlightpage",
        component: () => import("../V2/listlightpage.vue"),
        meta: { title: "Mobile Light Page - Smart Street Lighting" },
      },
      {
        path: "analytics",
        name: "v2-analytics",
        component: () => import("../V2/analytics.vue"),
        meta: { title: "Cluster Analytic Page - Smart Street Lighting" },
      },
      {
        path: "EventLogsPage",
        name: "v2-EventLogsPage",
        component: () => import("../V2/eventlog.vue"),
        meta: { title: "Event Log Page - Smart Street Lighting" },
      },
      {
        path: "lightpage",
        name: "v2-lightpage",
        component: () => import("../V2/lightpage.vue"),
        meta: { title: "Light Page- Smart Street Lighting" },
      },
      {
        path: "maintenance",
        name: "v2-maintenance",
        component: () => import("../V2/maintenancepage.vue"),
        meta: { title: "Maintenance - Smart Street Lighting" },
      },
      {
        path: "luxpage",
        name: "v2-luxpage",
        component: () => import("../V2/luxpage.vue"),
        meta: { title: "Lux Page - Smart Street Lighting" },
      },
      {
        path: "scheduler",
        children:
          [
            {
              path: "scheduler-time",
              name: "v2-scheduler-time",
              component: () => import("../V2/scheduler/scheduler-time.vue"),
              meta: { title: "Scheduler- Smart Street Lighting" },
            },
            {
              path: "scheduler-holidays",
              name: "v2-scheduler-holidays",
              component: () => import("../V2/scheduler/scheduler-holidays.vue"),
              meta: { title: "Scheduler- Smart Street Lighting" },
            },
          ]
      },
      {
        path: "administrator",
        children:
          [
            {
              path: "device",
              name: "v2-device",
              component: () => import("../V2/administrator/devicepage.vue"),
              meta: { title: "Administrator- Smart Street Lighting" },
            },
            {
              path: "gateway",
              name: "v2-gateway",
              component: () => import("../V2/administrator/gatewaypage.vue"),
              meta: { title: "Administrator- Smart Street Lighting" },
            },
            {
              path: "cluster",
              name: "v2-cluster",
              component: () => import("../V2/administrator/clusterpage.vue"),
              meta: { title: "Administrator- Smart Street Lighting" },
            },
            {
              path: "feeder-pillar",
              name: "v2-feeder-pillar",
              component: () => import("../V2/administrator/feederpillar.vue"),
              meta: { title: "Administrator- Smart Street Lighting" },
            },
          ]
      }
    ],
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }; // Always scroll to top
  }
});

router.beforeEach(async (to, from, next) => {
  const token = getCookies("token");
  const session = getCookies("session");
  const publicPaths = ["/oauth", "/V2/login",];
  const isPublic = publicPaths.includes(to.path);

  // Case: Public route and no session → allow
  if (isPublic && !session) return next();

  // Case: Public route but has session → check token and redirect accordingly
  if (isPublic && session) {
    if (!token) {
      if (!(await refreshToken(session))) {
        CleanUpCookies()
        return next("/V2/login");
      }
    } else {
      try {
        const { exp } = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000);
        if (now >= exp && !(await refreshToken(session))) {
          CleanUpCookies()
          return next("/V2/login");
        }

        return next("/V2/totalsolution"); // Valid token
      } catch (err) {
        CleanUpCookies()
        return next("/V2/login");
      } // Invalid token
    }
  }

  // Case: Private route and no session → redirect to login
  if (!isPublic && !session) {
    CleanUpCookies()
    return next("/V2/login");
  }

  // Case: Private route with session → verify token
  if (!isPublic && session) {
    if (!token) {
      if (!(await refreshToken(session))) {
        CleanUpCookies()
        return next("/V2/login");
      }
    } else {
      try {
        const decoded = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000);

        // Invalid service check
        if (decoded.iss !== "streetlight") {
          if (!(await refreshToken(session))) {
            CleanUpCookies()
            return next("/V2/login");
          }
        } else if (now >= decoded.exp) {
          if (!(await refreshToken(session))) {
            CleanUpCookies()
            return next("/V2/login");
          }
        }
      } catch (err) {
        CleanUpCookies()
        return next("/V2/login");
      } // Malformed token
    }
    return next(); // Token OK
  }

  next(); // Fallback
});

export default router;